
import React from 'react';
import { CustomerProduct } from '../../../../../client-staff/Components/CommanPages/CustomerProduct';

export default function ParentPurchasedProducts({ cmProfile }) {
    const products = Array.isArray(cmProfile?.purchase_product_data)
        ? cmProfile.purchase_product_data
        : [];

    return (
        <>
            <h4 className="title text-capitalize mt-5">
                Purchased Products
            </h4>

            {/* Show products when there are fewer than 3 */}
            {products.length > 0 && products.length < 3 && (
                <div className="row pt-4">
                    {products.map((product, index) => (
                        <div
                            className="col-md-6 col-lg-4"
                            key={product.product_id ?? index}
                        >
                            <div className="prelist-product p-3">
                                <div className="product-image">
                                    <img
                                        src={product.pro_image}
                                        alt={product.product_name || 'Product'}
                                        className="img-fluid d-block mx-auto"
                                    />
                                </div>

                                <div className="row align-items-center mt-5">
                                    <div className="col-7">
                                        <h6>{product.product_name}</h6>
                                    </div>

                                    <div className="col-5">
                                        <button
                                            type="button"
                                            className="btn btn-brandgreengrad d-block ml-auto"
                                        >
                                            ${product.price}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* Use CustomerProduct when there are 3 or more products */}
            {products.length >= 3 && (
                <div className="row pt-1">
                    <CustomerProduct pass={products} />
                </div>
            )}

            {/* Show message when there are no products */}
            {products.length === 0 && (
                <div>
                    <p className="text-center">No Records Found</p>
                </div>
            )}
        </>
    );
}
